import React from "react";
import { HeartFilled } from "@ant-design/icons";
import { HeartStyle } from "../data/data";
import Guy from "../../utils/images/himfooter.jpg";
import styled from "styled-components";

const Layout = styled.div`
  font-family: "Oswald", sans-serif;

  .name {
    color: white;
    font-size: 40px;
  }
`;

function HisFooter() {
  return (
    <>
      <Layout>
        <div style={styles.bgParallax}>
          <p>
            <HeartStyle>
              <span className="white-line"></span>
              <HeartFilled style={{ fontSize: 19, zIndex: 20, color: "red" }} />
              <HeartFilled
                style={{
                  fontSize: 19,
                  marginLeft: -5,
                  color: "white",
                }}
              />
              <span className="white-line"></span>
            </HeartStyle>
          </p>
          <p>
            <span className="name">UGBEDE & UFEDO</span>
          </p>
        </div>
      </Layout>
    </>
  );
}

const styles = {
  bgParallax: {
    background: `url(${Guy})`,
    height: 450,
    backgroundSize: "cover",
    // backgroundAttachment: "fixed",
    padding: 23,
    // opacity: 0.8,
    display: "flex",
    flexDirection: "column",
    justifyContent: "Center",
    alignItems: "center",
  },
};

export default HisFooter;
